import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);
  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <MotionContent imgRef={heroRef} height={"h-[110vh]"} translateRange={["10%", "-10%"]} className="bg-black lg:aspect-square">
            <ImageMedia
              key={"hero"+thisProject.client}
              src={require('./_cover.jpg')}
              className="relative md:landscape:scale-[110%] full object-contain aspect-square object-center"
            />
          </MotionContent>
        </div>
      )}
    </ThisProject>
  )
}

export default Content